import { observer } from 'mobx-react-lite'
import { Alert, Tabs } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { RegistrationAuthoritySelect } from 'pages/settings/pages/compliance/ui/RegistrationAuthoritySelect'
import { AutoBusinessFind } from './AutoBusinessFind'
import { ManuallyBusinessFind } from './ManuallyBusinessFind'
import styles from './styles.module.scss'

export const BusinessInfo = observer(() => {
  const { stepLoading, businessInfoStore } = useTollFreeStepsContext()
  const {
    generalInfoActiveTab,
    changeGeneralInfoTab,
    nextStepClick,
    isNextDisabled,
    registrationAuthorityStore,
    resetData,
  } = businessInfoStore

  const {
    isDontHaveBusinessTaxID,
    isLocationEmpty,
    isUSLocation,
    isCALocation,
    businessTaxIDLink,
  } = registrationAuthorityStore

  return (
    <div className={styles.wrap}>
      <div className={styles.bannerWrap}>
        <PageDescription>Enter your business details for carrier verification</PageDescription>
      </div>

      <RegistrationAuthoritySelect store={registrationAuthorityStore} onCountryChange={resetData} />

      {!isLocationEmpty && (
        <>
          {isUSLocation && (
            <>
              <Tabs
                tabs={[
                  { name: 'Find your business', key: 1 },
                  { name: 'Enter manually', key: 2 },
                ]}
                activeTabKey={generalInfoActiveTab}
                handleSelectTab={(tab) => changeGeneralInfoTab(tab.key)}
                margin={'0 0 28px 0'}
              />
              {generalInfoActiveTab === 1 && <AutoBusinessFind />}
              {generalInfoActiveTab === 2 && <ManuallyBusinessFind />}
            </>
          )}

          {isCALocation && <ManuallyBusinessFind />}

          {!isDontHaveBusinessTaxID && (
            <NextButton
              loading={stepLoading}
              disabled={isNextDisabled || stepLoading}
              text='Next'
              onClick={nextStepClick}
            />
          )}

          {isDontHaveBusinessTaxID && (
            <Alert
              marginTop={32}
              item={{
                type: 'warning',
                title: 'Business Tax ID is required.',
                desc: 'Texting from toll-free numbers to the US or Canada isn’t available without a Tax ID.',
              }}
              actions={[
                {
                  variant: 'link',
                  type: 'primary',
                  text: 'Get a business Tax ID',
                  link: businessTaxIDLink,
                },
              ]}
            />
          )}
        </>
      )}
    </div>
  )
})
